export const data = [
  {
    id: 1,
    date: "2023-08-05",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "83.44",
    status: "En entrega",
  },
  {
    id: 2,
    date: "2023-11-28",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "14.97",
    status: "Enviado",
  },
  {
    id: 3,
    date: "2023-11-09",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "70.84",
    status: "En entrega",
  },
  {
    id: 4,
    date: "2023-10-08",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "12.99",
    status: "En entrega",
  },
  {
    id: 5,
    date: "2023-12-06",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "123 Main Street, City",
    price: "26.96",
    status: "Nueva orden",
  },
  {
    id: 6,
    date: "2023-08-28",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "54.96",
    status: "Enviado",
  },
  {
    id: 7,
    date: "2023-06-15",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "24.12",
    status: "Nueva orden",
  },
  {
    id: 8,
    date: "2023-07-28",
    name: "Jane Smith",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "25.23",
    status: "En entrega",
  },
  {
    id: 9,
    date: "2023-09-07",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "72.12",
    status: "En entrega",
  },
  {
    id: 10,
    date: "2023-01-12",
    name: "Jane Smith",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "19.87",
    status: "Nueva orden",
  },
  {
    id: 11,
    date: "2023-05-27",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "456 Oak Avenue, Town",
    price: "86.35",
    status: "En entrega",
  },
  {
    id: 12,
    date: "2023-01-14",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "56.86",
    status: "En entrega",
  },
  {
    id: 13,
    date: "2023-07-27",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "99.99",
    status: "Nueva orden",
  },
  {
    id: 14,
    date: "2023-12-10",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "456 Oak Avenue, Town",
    price: "74.39",
    status: "En entrega",
  },
  {
    id: 15,
    date: "2023-02-16",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "83.78",
    status: "Enviado",
  },
  {
    id: 16,
    date: "2023-11-10",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "79.35",
    status: "Enviado",
  },
  {
    id: 17,
    date: "2023-04-13",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "90.36",
    status: "Nueva orden",
  },
  {
    id: 18,
    date: "2023-11-27",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "33.14",
    status: "Nueva orden",
  },
  {
    id: 19,
    date: "2023-12-09",
    name: "Jane Smith",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "23.03",
    status: "Nueva orden",
  },
  {
    id: 20,
    date: "2023-01-08",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "12.00",
    status: "Enviado",
  },
  {
    id: 21,
    date: "2023-01-18",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "94.25",
    status: "Nueva orden",
  },
  {
    id: 22,
    date: "2023-06-02",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "38.17",
    status: "En entrega",
  },
  {
    id: 23,
    date: "2023-03-14",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "123 Main Street, City",
    price: "10.12",
    status: "En entrega",
  },
  {
    id: 24,
    date: "2023-07-27",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "123 Main Street, City",
    price: "55.63",
    status: "En entrega",
  },
  {
    id: 25,
    date: "2023-05-11",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "13.09",
    status: "En entrega",
  },
  {
    id: 26,
    date: "2023-11-10",
    name: "Jane Smith",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "1.65",
    status: "En entrega",
  },
  {
    id: 27,
    date: "2023-02-02",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "123 Main Street, City",
    price: "16.59",
    status: "En entrega",
  },
  {
    id: 28,
    date: "2023-12-03",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "61.54",
    status: "En entrega",
  },
  {
    id: 29,
    date: "2023-05-04",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "55.71",
    status: "Enviado",
  },
  {
    id: 30,
    date: "2023-04-17",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "16.84",
    status: "Enviado",
  },
  {
    id: 31,
    date: "2023-01-18",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "14.50",
    status: "Enviado",
  },
  {
    id: 32,
    date: "2023-12-26",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "14.60",
    status: "Enviado",
  },
  {
    id: 33,
    date: "2023-03-24",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "123 Main Street, City",
    price: "87.20",
    status: "Nueva orden",
  },
  {
    id: 34,
    date: "2023-02-20",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "456 Oak Avenue, Town",
    price: "23.31",
    status: "Enviado",
  },
  {
    id: 35,
    date: "2023-04-07",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "82.51",
    status: "Nueva orden",
  },
  {
    id: 36,
    date: "2023-08-19",
    name: "Jane Smith",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "65.60",
    status: "Nueva orden",
  },
  {
    id: 37,
    date: "2023-08-18",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "90.40",
    status: "Nueva orden",
  },
  {
    id: 38,
    date: "2023-01-18",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "61.69",
    status: "Enviado",
  },
  {
    id: 39,
    date: "2023-08-27",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "456 Oak Avenue, Town",
    price: "26.39",
    status: "Enviado",
  },
  {
    id: 40,
    date: "2023-08-23",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "789 Pine Road, Village",
    price: "1.27",
    status: "Enviado",
  },
  {
    id: 41,
    date: "2023-07-26",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "52.86",
    status: "Enviado",
  },
  {
    id: 42,
    date: "2023-05-21",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "456 Oak Avenue, Town",
    price: "3.28",
    status: "En entrega",
  },
  {
    id: 43,
    date: "2023-12-19",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "25.46",
    status: "Enviado",
  },
  {
    id: 44,
    date: "2023-12-19",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "37.13",
    status: "Nueva orden",
  },
  {
    id: 45,
    date: "2023-08-02",
    name: "Bob Johnson",
    branchDistributor: "sucursal en distribuidores",

    location: "123 Main Street, City",
    price: "80.11",
    status: "En entrega",
  },
  {
    id: 46,
    date: "2023-05-19",
    name: "John Doe",
    branchDistributor: "sucursal en distribuidores",

    location: "456 Oak Avenue, Town",
    price: "94.36",
    status: "Enviado",
  },
  {
    id: 47,
    date: "2023-01-05",
    name: "Alice Williams",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "74.01",
    status: "En entrega",
  },
  {
    id: 48,
    date: "2023-04-27",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "123 Main Street, City",
    price: "44.34",
    status: "Nueva orden",
  },
  {
    id: 49,
    date: "2023-12-26",
    name: "Charlie Brown",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "92.27",
    status: "Enviado",
  },
  {
    id: 50,
    date: "2023-01-27",
    name: "Jane Smith",
    branchDistributor: "sucursal en distribuidores",
    location: "789 Pine Road, Village",
    price: "55.57",
    status: "Enviado",
  },
];
